import { render } from "./NText.vue?vue&type=template&id=f41ea420&ts=true"
import script from "./NText.vue?vue&type=script&lang=ts"
export * from "./NText.vue?vue&type=script&lang=ts"

import "./NText.vue?vue&type=style&index=0&id=f41ea420&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__